/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
// nm2024 themed components
import { LinkNm2024  } from '../../../../nm2024Theme/components/link/styles';
// NM 2024 theme
import Nm2024Theme from '../../../../nm2024Theme/nm2024Theme/colors';

export const ColStyled = styled(Col)`
  ${({ theme, disableBorder, disableTopPadding, disableBottomPadding }) => {
    const largeUp = theme.largeUp();
    const largeDown = theme.largeDown();
    const paddingLeft = largeUp ? rem(45) : 0;
    const verticalPadding = largeUp ? 0 : rem(32);

    return css`
      border-right: ${(disableBorder || largeDown) ? 'none' : rem(1)} solid ${Nm2024Theme.maroon.maroon};
      border-bottom: ${(disableBorder || largeUp) ? 'none' : rem(1)} solid ${Nm2024Theme.maroon.maroon};
      padding-left: ${paddingLeft};
      padding-right: ${paddingLeft};
      padding-top: ${disableTopPadding ? 0 : verticalPadding};
      padding-bottom: ${disableBottomPadding ? 0 : verticalPadding};
    `;
  }}
`;

export const LinkStyled = styled(LinkNm2024)`
  ${({ theme }) => {
    const smallDown = theme.smallDown();
    return css`
      display: flex;
      margin: 0 auto;
      ${smallDown && `
        width: 100%;
        max-width: none;
      `}
    `;
  }
}`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let paddingLeft = rem(5);
    let paddingRight = rem(15);
    let maxWidth = rem(375);

    if(largeUp){
      paddingLeft = rem(30);
      paddingRight = rem(30);
      maxWidth = rem(200);
    } else if(mediumUp){
      paddingLeft = 0;
      paddingRight = rem(25);
    } else if(smallUp){
      paddingLeft = rem(15);
      paddingRight = rem(25);
    }

    return css`
      padding-left: ${paddingLeft};
      padding-right: ${paddingRight};
      padding-bottom: ${largeUp ? rem(20) : 0};
      max-width: ${maxWidth };
      margin: 0 auto;
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(40) : rem(32)};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const verticalPadding = mediumUp ? rem(52) : rem(48);
    return css`
      padding-top: ${verticalPadding};
      padding-bottom: ${verticalPadding};
    `;
  }
}`;

